import { render, staticRenderFns } from "./ViaCepSearch.vue?vue&type=template&id=2462e787&scoped=true"
import script from "./ViaCepSearch.vue?vue&type=script&lang=js"
export * from "./ViaCepSearch.vue?vue&type=script&lang=js"
import style0 from "./ViaCepSearch.vue?vue&type=style&index=0&id=2462e787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2462e787",
  null
  
)

export default component.exports